module.exports = __webpack_public_path__ + "img/market-banner__list.svg?4d187f1e9e8bef25541c42974406d124";